// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"e699a115","750":"6b8274ec","2775":"91a13d17","2947":"11b01132","4088":"3e4b7445","8180":"83dbd7d2","8662":"95bed5f4"}[chunkId] + ".chunk.css";
};